<div class="w-full bg-white flex flex-col justify-center items-center gap-1 p-5 relative">
	<div mat-dialog-close
		 class="absolute top-0 left-0 px-2 pt-2 primary-color rounded">
			<span class="material-symbols-outlined cursor-pointer text-white">
				close
			</span>
	</div>
	<p class="text-xl text-center">It seems like you've been signed out.</p>
	<p class="text-xl text-center"> Please log in to access your cart and continue shopping.</p>
	<a routerLink="/auth" (click)="storeUrl()"
	   class="max-w-[200px] w-full secondary-button py-1 px-3 rounded
						transition flex items-center justify-center gap-2 text-sm sm:text-base mt-4">
		<span class="">Sign In</span>
	</a>
</div>
